import { Injectable, Optional } from '@angular/core';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Repository } from '@farris/devkit';
import { BefRepository, BefRestService, RequestInfo, ResponseInfo } from '@farris/bef';
import { BodyWithRequestInfo } from './types';
import { FormLoadingService } from './form-loading/form-loading.service';
import { FormMessageService } from './form-message.service';
import { FormNotifyService } from './form-notify.service';
import { FormErrorService } from './error/form-error.service';
import { LanguageService } from './languag.service';
// tslint:disable: no-string-literal

/**
 * åè¡¨ä»åºæå¡
 * @scope FrameComponent
 */
@Injectable()
class BeActionService {

  /**
   * æé å½æ°
   */
  constructor(
    private repository: Repository<any>,
    private loadingService: FormLoadingService,
    private msgService: FormMessageService,
    private notifyService: FormNotifyService,
    private formErrorService: FormErrorService,
    @Optional() private languageService: LanguageService,
  ) {
    if (!this.languageService) {
      this.languageService = LanguageService.getInstance();
    }
  }

  /**
   * æ§è¡èªå®ä¹å¨ä½
   */
  public invokeAction(
    actionUri: string, httpMethod: string, httpHeaders?: any, queryParams?: any, body?: BodyWithRequestInfo
  ): Observable<ResponseInfo> {
    return this.innerInvokeAction(actionUri, httpMethod, httpHeaders, queryParams, body, true);
  }

  /**
   * å·²å¼ç¨ï¼è¯·ä½¿ç¨invokeActionä»£æ¿
   * @deprecated
   * @summary
   * è¿ç§»æ¶è¯·æ³¨æï¼invokeActionä¸­bodyè¯·ä¼ éæ»¡è¶³BodyWithRequestInfoæ¥å£çæ ¼å¼ï¼å½¢å¦ï¼
   * { requestInfo: reqeustInfoInstance, key1: value1, key2: value2 }
   */
  public executeAction(
    actionUri: string, httpMethod: string, httpHeaders?: any, queryParams?: any, body?: any
  ): Observable<any> {

    // 1ãä¸ç¡®å®bodyä¸­æ¯å¦æRequestInfoå¯¹è±¡
    // 2ãrestServiceçreqeustä¼æ ¹æ®bodyä¸­æ¯å¦ækeyä¸ºReqeustInfoï¼å¤§åå¼å¤´ï¼çåæ°æ¥ç¡®å®ï¼
    // 3ãå¦æbodyä¸­æ²¡ækeyä¸ºReqeustInfoçåæ°ï¼ä¸ç´æ¥è¿åResponseInfoï¼èæ¯è¿ä¸æ­¥è§£æï¼è¿åå¶ä¸­çreturnValueã
    return this.innerInvokeAction(actionUri, httpMethod, httpHeaders, queryParams, body, false);
  }

  /**
   * æé æ¥è¯¢å­ç¬¦ä¸²
   */
  public buildQueryParams(queryParams: string): string {
    if (typeof queryParams === 'string') {
      queryParams = JSON.parse(queryParams);
    }

    let queryParamsString = '';
    Object.keys(queryParams).forEach((key: string) => {
      queryParamsString += `${key}=${queryParams[key]}`;
    });

    return queryParamsString;
  }

  /**
   * è·åRestæå¡
   */
  public getRestService(): BefRestService {
    const befRepository = this.repository as BefRepository<any>;
    return befRepository.restService;
  }


  /**
   * è°ç¨èªå®ä¹å¨ä½
   */
  private innerInvokeAction(
    actionUri: string, httpMethod: string, httpHeaders?: any, queryParams?: any, body?: any, hasRequestInfo?: boolean
  ): Observable<any>  {
    const options = {};
    const restService = this.getRestService();
    const baseUri = restService.baseUri;

    // æé url
    let fullActionUri = `${baseUri}/service/${actionUri}`;
    if (queryParams && queryParams !== '') {
      const queryParamsString = this.buildQueryParams(queryParams);
      fullActionUri += queryParamsString;
    }


    // bodyæé 
    if (body && body !== '') {
      if (typeof body === 'string' && body.startsWith('{') && body.endsWith('}')) {
        body = JSON.parse(body);
      }
      options['body'] = body;
    }

    // httpå¤´æé 
    if (httpHeaders && httpHeaders !== '') {
      httpHeaders = JSON.parse(httpHeaders);

      // å¦ææ²¡æè®¾ç½®Content-Typeï¼é»è®¤ç¨jsonæ ¼å¼
      if (!httpHeaders['Content-Type']) {
        httpHeaders['Content-Type'] = 'application/json';
      }
      options['headers'] = new HttpHeaders(httpHeaders);
    } else {
      options['headers'] = new HttpHeaders({ 'Content-Type': 'application/json' });
    }

    // æ§è¡æå¡å¨ç«¯è¯·æ±
    this.loadingService.show();

    // invokeæ¹æ³
    // 1ãRequestInfo=>æ¥é
    // 2ãrequestInfo=>ResponseInfo
    // requestæ¹æ³
    // 1ãRequestInfo=>ResponseInfo
    // 2ãrequestInfo=>returnValue
    const methodName = hasRequestInfo ? 'invoke' : 'request';
    const result$ = restService[methodName](fullActionUri, httpMethod, null, options);
    return result$.pipe(
      tap(
        () => {
          this.loadingService.hide();
        },
        (error: any) => {
          this.loadingService.hide();
          const errorMsg = fullActionUri + this.languageService['operationFailed'];
          this.formErrorService.exception(errorMsg, error);
        }
      )
    );
  }
}


export { BeActionService };


